﻿export function base64toBlob(b64Data: string, contentType = '', sliceSize = 512)
{
    const byteCharacters = atob(b64Data);
    const byteArrays: BlobPart[] = [];
    
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export function dataURLtoBlob(dataurl:string):Blob {
    const separator = dataurl.indexOf(',');
    if (separator < 0) throw new Error('Invalid data URL: missing payload separator.');
    const header = dataurl.slice(0, separator);
    const mimeMatch = header.match(/:(.*?);/);
    if (!mimeMatch?.[1]) throw new Error('Invalid data URL: missing MIME type.');

    const mime = mimeMatch[1];
    const bstr = atob(dataurl.slice(separator + 1));
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}

export async function blobToDataURL(blob: any):Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const a = new FileReader();
        a.onload = () => {
            if (typeof a.result === 'string') resolve(a.result);
            else reject(new Error('FileReader did not produce a data URL.'));
        };
        a.onerror = () => reject(a.error ?? new Error('Cannot read blob as a data URL.'));
        try { a.readAsDataURL(blob); } catch (e)
            { reject(e); }
    });
}

export function blobToFile(blob:Blob, filename:string):File
{        
    let file = new File([blob], filename, {type: blob.type, lastModified: Date.now()});
    return file;
}
